import { Flex, Form, Input } from 'antd'
import { useTranslation } from 'react-i18next'

import { paths } from 'src/router'

import { AuthLink } from './AuthLink'
import { EmailInput } from './EmailInput'

type LoginFormItemsProps = {
  autoFocus?: 'username' | 'password' | false
}

export const LoginFormItems = ({
  autoFocus = 'username'
}: LoginFormItemsProps) => {
  const { t } = useTranslation()
  const form = Form.useFormInstance()
  const username = Form.useWatch('username', form)
  const resetPasswordState =
    typeof username === 'string' && username.trim()
      ? { username: username.trim() }
      : undefined

  return (
    <Flex orientation="vertical" gap={10}>
      <EmailInput
        name="username"
        label={t('email')}
        autoFocus={autoFocus === 'username'}
      />

      <Flex orientation="vertical" gap={8}>
        <Form.Item
          name="password"
          label={t('password')}
          style={{ marginBottom: 0 }}
        >
          <Input.Password
            placeholder={t('input_placeholder_password')}
            autoComplete="current-password"
            autoFocus={autoFocus === 'password'}
          />
        </Form.Item>

        <AuthLink to={paths.auth.resetPassword} state={resetPasswordState}>
          {t('forgot_password')}
        </AuthLink>
      </Flex>
    </Flex>
  )
}
